import React, { useEffect, useState } from 'react';
import BackDropLoading from 'Utils/Loading';
import SideMenu from './AppMenu/SideMenu';
import UpMenu from './AppMenu/UpMenu';
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { user_data } from 'http/components/UserService';
import { HandleLoading } from "Utils/Helpers/HandleLoading";
import { SetUserData } from 'Utils/Helpers/HandleApiData';
import { enqueueSnackbar } from 'notistack';

export default function HomeIndex() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user, clinic, loading, isLogin } = useSelector((state) => ({
        user: state.user.name,
        clinic: state.user.clinic,
        loading: state.setting.loading,
        isLogin: state.user.isLogin,
    }));
    const [up, setUp] = useState(false);

    useEffect(() => {
        (async () => {
            if(!isLogin) {
                navigate('/');
            } else {
                dispatch(HandleLoading(true));
                const response = await user_data();
                if(response.status) {
                    dispatch(SetUserData(response.data, navigate))
                } else {
                    enqueueSnackbar('اطلاعات سیستم به درستی دریافت نشده است', {variant: 'error'});
                    dispatch(HandleLoading(false));
                }
                setUp(true);
            }
        })()
    },[dispatch, navigate, isLogin])

    return (
        <>
            {
                up && isLogin &&
                <div className='app-home' id='app-home'>
                    <BackDropLoading loading={loading}/>
                    <SideMenu user_name={user} clinic_name={clinic}/>
                    <div className='home-body'>
                        <div className='inner'>
                            <UpMenu user_name={user} clinic_name={clinic}/>
                            <div className='hbody'>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}